/**
 * Course Generator Amplitude helpers.
 *
 * Autocapture is the only tracker (no custom generator events). Stable `id`s
 * land as `[Amplitude] Element ID`. While the modal is open, an enrichment
 * plugin attributes the page title to Course Generator. Progression IDs also
 * encode the source step captured at click time, without reading mutable wizard
 * state after navigation. Path and URL stay on the real page underneath.
 */

export const COURSE_GENERATOR_AMPLITUDE_PAGE_TITLE = 'Course Generator';

const PAGE_TITLE = '[Amplitude] Page Title';
const ELEMENT_ID = '[Amplitude] Element ID';
const STEP_PROPERTY = 'Course Generator Step';

let courseGeneratorAmplitudeSurfaceActive = false;

export function setCourseGeneratorAmplitudeSurface(active) {
    courseGeneratorAmplitudeSurfaceActive = Boolean(active);
}

export function isCourseGeneratorAmplitudeSurfaceActive() {
    return courseGeneratorAmplitudeSurfaceActive;
}

export function resetCourseGeneratorAmplitudeSurface() {
    courseGeneratorAmplitudeSurfaceActive = false;
}

export function applyCourseGeneratorAmplitudePage(event) {
    if (!event) return event;

    // Match only the static progression IDs on this four-step wizard. A queued
    // click remains attributable even if the modal has since closed; unrelated
    // events never inherit a remembered step.
    const progression =
        event.event_type === '[Amplitude] Element Clicked'
            ? /^cg-field-(?:next|generate|finalize)-step-([1-4])$/.exec(event.event_properties?.[ELEMENT_ID])
            : null;

    if (!courseGeneratorAmplitudeSurfaceActive && !progression) return event;

    event.event_properties = {
        ...(event.event_properties ?? {}),
        [PAGE_TITLE]: COURSE_GENERATOR_AMPLITUDE_PAGE_TITLE,
        ...(progression ? { [STEP_PROPERTY]: Number(progression[1]) } : {}),
    };

    return event;
}

export function courseGeneratorAmplitudePagePlugin() {
    return {
        name: 'course-generator-amplitude-page',
        type: 'enrichment',
        setup: async () => undefined,
        execute: async event => applyCourseGeneratorAmplitudePage(event),
    };
}

export function courseGeneratorFieldDomId(keyOrLabel) {
    const slug = String(keyOrLabel ?? '')
        .replace(/([a-z])([A-Z])/g, '$1-$2')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');

    return slug ? `cg-field-${slug}` : undefined;
}
